import dynamic from "next/dynamic";

const ForgotPassword = dynamic(
  () => import("@Components/Pages/Forgot-password"),
  {
    ssr: false,
  }
);

export default function LoginPage() {
  return <ForgotPassword />;
}
LoginPage.displayName = "login";
